export const adaptModoInfusion = (modoInfusionData) => {
    return {
        id: modoInfusionData?.idComboRIValor,
        displayName: modoInfusionData?.valor,
        name: modoInfusionData?.valor
    }
}

export const adaptModoInfusionArray = (
    modosInfusion
) => {
    return structuredClone(modosInfusion?.comboRI?.comboRIValor)
        ?.map(modoInfusion => adaptModoInfusion(modoInfusion));
}